module.exports = __webpack_public_path__ + "img/logo.d315c557.svg";